import React from "react";
import classnames from "classnames";
import map from "lodash/map";

import { iconUses } from "../../reducers/download";

export default props => {
    let { download } = props;
    let choicesList = map(iconUses, (useType, key) => {
        let text = useType.title;
        let choiceClass = classnames({
            current: download.attributionType == key
        });
        return (
            <li
                className={choiceClass}
                key={key}
                onClick={props.downloadSelectAttribution.bind(null, key)}
            >
                {text}
            </li>
        );
    });

    let canAdvance = !!props.download.attributionType;
    let buttonClass = classnames("button", {
        green: canAdvance,
        disabled: !canAdvance
    });
    let buttonAction = props.downloadCommitAttribution;

    return (
        <div>
            <div>How do you plan to use this icon?</div>
            <ul className="attribution-types bubble-choices">{choicesList}</ul>
            <button className={buttonClass} onClick={buttonAction}>
                Choose Use
            </button>
        </div>
    );
};
